// One place for how a script format is badged (Longform = violet-muted "LF").
export function formatLabel(format) {
  if (format === 'TH') return 'Talking Head';
  if (format === 'Longform') return 'LF';
  return format || '';
}
export function formatBadgeClass(format) {
  return format === 'Longform' ? 'format-badge lf' : 'format-badge';
}
export function formatTitle(format) {
  return format === 'Longform' ? 'Longform series — episodes are production cards' : undefined;
}
